import { render } from "./Bumil.vue?vue&type=template&id=59bf38ca"
import script from "./Bumil.vue?vue&type=script&lang=js"
export * from "./Bumil.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__